const ModalComponent = ({ id, title, children, big }: { id: string, title: string, children: JSX.Element, big?: boolean }) => {

    return (
        <div className="modal fade" id={id} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className={big ? `modal-dialog modal-xl` : 'modal-dialog'}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-dark" id="exampleModalLabel">{title}</h5>
                        <button type="button" className="btn btn-text-dark" onClick={() => (window as any).$("#" + id).modal('hide')}>
                            <i className="material-icons">close</i>
                        </button>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>                    
                </div>
            </div>
        </div>
    )

}

export default ModalComponent;